type Props = {
  size?: number;
  color?: string;
  className?: string;
};

export const OffTakerIcon = ({
  size = 16,
  color = "currentColor",
  className,
}: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 65 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="0.277344"
        y="0.866943"
        width="64.6903"
        height="64.6903"
        rx="32.3451"
        fill={color}
        fillOpacity="0.21"
      />
      <path
        d="M32.3435 30.5765C34.9457 30.5765 37.0551 28.467 37.0551 25.8649C37.0551 23.2627 34.9457 21.1532 32.3435 21.1532C29.7413 21.1532 27.6318 23.2627 27.6318 25.8649C27.6318 28.467 29.7413 30.5765 32.3435 30.5765Z"
        stroke={color}
        strokeWidth="2.35583"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.9446 44.7114C42.9446 38.8566 38.1982 34.1102 32.3434 34.1102C26.4886 34.1102 21.7422 38.8566 21.7422 44.7114"
        stroke={color}
        strokeWidth="2.35583"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.3431 44.7114L34.699 41.7666L32.3431 34.1102L29.9873 41.7666L32.3431 44.7114Z"
        stroke={color}
        strokeWidth="2.35583"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
